import { useEffect, useState } from 'react';

const STORAGE_KEY = 'planforvaltning.lastSeenVersion';

export function useNewVersionNotice() {
    const [hasNewVersion, setHasNewVersion] = useState(false);

    useEffect(() => {
        try {
            const lastSeen = window.localStorage.getItem(STORAGE_KEY);
            if (lastSeen && lastSeen !== __APP_VERSION__) {
                setHasNewVersion(true);
            } else if (!lastSeen) {
                window.localStorage.setItem(STORAGE_KEY, __APP_VERSION__);
            }
        } catch {
            // localStorage utilgjengelig (privat modus, SSR osv.) — fall tilbake til ingen notifikasjon
        }
    }, []);

    const dismiss = () => {
        try {
            window.localStorage.setItem(STORAGE_KEY, __APP_VERSION__);
        } catch {
            // ignorer
        }
        setHasNewVersion(false);
    };

    return { hasNewVersion, dismiss };
}
